import React from 'react';

const User = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27">
        <path
            fill="currentColor"
            fillRule="nonzero"
            d="M18.513 14.458a8.068 8.068 0 0 0 2.659-9.011A8.137 8.137 0 0 0 13.48 0a8.137 8.137 0 0 0-7.692 5.447 8.068 8.068 0 0 0 2.659 9.01A13.503 13.503 0 0 0 .008 25.495a1.36 1.36 0 0 0 1.208 1.498 1.363 1.363 0 0 0 1.506-1.201c.616-5.46 5.26-9.589 10.785-9.589s10.169 4.128 10.785 9.589a1.354 1.354 0 0 0 1.357 1.2h.15a1.351 1.351 0 0 0 1.193-1.483 13.503 13.503 0 0 0-8.479-11.05ZM13.48 13.5c-2.997 0-5.427-2.417-5.427-5.397 0-2.98 2.43-5.397 5.427-5.397 2.997 0 5.427 2.416 5.427 5.397a5.382 5.382 0 0 1-1.59 3.816 5.442 5.442 0 0 1-3.837 1.58Z"
        />
    </svg>
);

export default User;
